import { TThunkAction } from '../../types/redux/thunk';
import { promosRequestAction } from '../promos';

/**
 * Redux action, который запрашивает объявления с текущем состоянием nextJsonQuery
 */
export const promosApplyFiltersRequestAction = (): TThunkAction<Promise<void>> => async dispatch => {
  await dispatch(promosRequestAction());
};
